export default __webpack_public_path__ + "static/media/image006.415c2717.png";